import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class DeleteManuelltDestineringsalternativCommand extends BasicCommand<DeleteManuelltDestineringsalternativCommand> {
    get primaryKey(): IPrimaryKey<DeleteManuelltDestineringsalternativCommand> {
        return {
            arbetsorderId: this.arbetsorderId,
            handelssortimentId: this.handelssortimentId,
            mottagningsplatsId: this.mottagningsplatsId,
            destineringsursprung: this.destineringsursprung,
            foradlatHandelssortimentId: this.foradlatHandelssortimentId
        };
    }
    arbetsorderId: number;
    handelssortimentId: number;
    mottagningsplatsId: number;
    destineringsursprung: number;
    foradlatHandelssortimentId: number;
    egenskapskodX: boolean;
    overstyrdAvlastningsplats: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteManuelltDestineringsalternativCommand";
    constructor(arbetsorderId: number,
        handelssortimentId: number,
        mottagningsplatsId: number,
        destineringsursprung: number,
        foradlatHandelssortimentId?: number) {
        super(DeleteManuelltDestineringsalternativCommand.$type, "Arbetsorder", CommandType.Replace);
        this.arbetsorderId = arbetsorderId;
        this.handelssortimentId = handelssortimentId;
        this.mottagningsplatsId = mottagningsplatsId;
        this.destineringsursprung = destineringsursprung;
        this.foradlatHandelssortimentId = foradlatHandelssortimentId;
    }
}
